import { FormController } from "./controller";

export const forms = {
    create<T extends Record<string, unknown>>(initialValue: T) {
        return new FormController<T>(initialValue);
    },
};

import { default as FormInputAgent } from "./composite/FormInputAgent.vue";
import { default as FormInputDiscount } from "./composite/FormInputDiscount.vue";
import { default as FormInputInvoiceItem } from "./composite/FormInputInvoiceItem.vue";
import { default as FormInputLAN } from "./composite/FormInputLAN.vue";
import { default as FormInputNetwork } from "./composite/FormInputNetwork.vue";
import { default as FormInputPrivilege } from "./composite/FormInputPrivilege.vue";
import { default as FormInputProductHotspot } from "./composite/FormInputProductHotspot.vue";
import { default as FormInputProfit } from "./composite/FormInputProfit.vue";
import { default as FormInputProvision } from "./composite/FormInputProvision.vue";
import { default as FormInputProvisionItemSelect } from "./composite/FormInputProvisionItemSelect.vue";
import { default as FormInputProvisionItemStatus } from "./composite/FormInputProvisionItemStatus.vue";
import { default as FormInputRadiusAuth } from "./composite/FormInputRadiusAuth.vue";
import { default as FormInputRadiusConfig } from "./composite/FormInputRadiusConfig.vue";
import { default as FormInputVoucherTemplate } from "./composite/FormInputVoucherTemplate.vue";
import { default as FormInputWAN } from "./composite/FormInputWAN.vue";
import { default as FormInputWiFi } from "./composite/FormInputWiFi.vue";
import { default as FormButton } from "./FormButton.vue";
import { default as FormColumn } from "./FormColumn.vue";
import { default as FormGrid } from "./FormGrid.vue";
import { default as FormSubmit } from "./FormSubmit.vue";
import { default as FormTitleEdit } from "./FormTitleEdit.vue";
import { default as FormTitleView } from "./FormTitleView.vue";
import { default as FormWrap } from "./FormWrap.vue";
import { default as FormInputCheckbox } from "./input/FormInputCheckbox.vue";
import { default as FormInputDate } from "./input/FormInputDate.vue";
import { default as FormInputFile } from "./input/FormInputFile.vue";
import { default as FormInputFileImage } from "./input/FormInputFileImage.vue";
import { default as FormInputLocation } from "./input/FormInputLocation.vue";
import { default as FormInputNumeric } from "./input/FormInputNumeric.vue";
import { default as FormInputNumericUnit } from "./input/FormInputNumericUnit.vue";
import { default as FormInputPassword } from "./input/FormInputPassword.vue";
import { default as FormInputRating } from "./input/FormInputRating.vue";
import { default as FormInputSelect } from "./input/FormInputSelect.vue";
import { default as FormInputSelectMulti } from "./input/FormInputSelectMulti.vue";
import { default as FormInputSignature } from "./input/FormInputSignature.vue";
import { default as FormInputText } from "./input/FormInputText.vue";
import { default as FormInputTextArea } from "./input/FormInputTextArea.vue";
import { default as FormInputTextComplete } from "./input/FormInputTextComplete.vue";
import { default as FormInputTextRich } from "./input/FormInputTextRich.vue";
import { default as FormInputTime } from "./input/FormInputTime.vue";
import { default as FormInputToggle } from "./input/FormInputToggle.vue";

export const Form = {
    Button: FormButton,
    Column: FormColumn,
    Grid: FormGrid,
    InputAgent: FormInputAgent,
    InputCheckbox: FormInputCheckbox,
    InputDate: FormInputDate,
    InputDiscount: FormInputDiscount,
    InputFile: FormInputFile,
    InputFileImage: FormInputFileImage,
    InputInvoiceItem: FormInputInvoiceItem,
    InputLAN: FormInputLAN,
    InputLocation: FormInputLocation,
    InputNetwork: FormInputNetwork,
    InputNumeric: FormInputNumeric,
    InputNumericUnit: FormInputNumericUnit,
    InputPassword: FormInputPassword,
    InputPrivilege: FormInputPrivilege,
    InputProductHotspot: FormInputProductHotspot,
    InputProfit: FormInputProfit,
    InputProvision: FormInputProvision,
    InputProvisionItemSelect: FormInputProvisionItemSelect,
    InputProvisionItemStatus: FormInputProvisionItemStatus,
    InputRadiusAuth: FormInputRadiusAuth,
    InputRadiusConfig: FormInputRadiusConfig,
    InputRating: FormInputRating,
    InputSelect: FormInputSelect,
    InputSelectMulti: FormInputSelectMulti,
    InputSignature: FormInputSignature,
    InputText: FormInputText,
    InputTextArea: FormInputTextArea,
    InputTextComplete: FormInputTextComplete,
    InputTextRich: FormInputTextRich,
    InputTime: FormInputTime,
    InputToggle: FormInputToggle,
    InputVoucherTemplate: FormInputVoucherTemplate,
    InputWAN: FormInputWAN,
    InputWiFi: FormInputWiFi,
    Submit: FormSubmit,
    TitleEdit: FormTitleEdit,
    TitleView: FormTitleView,
    Wrap: FormWrap,
};
